(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/draw-days.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/draw-days.js');

'use strict';

svs.numbergames.game.views.DrawDays = Marionette.View.extend({
  className: 'numbergames-footer-section',
  ui: {
    drawDaysCheckbox: '.js-draw-days-checkbox',
    drawDaysInfo: '.js-draw-days-info'
  },
  triggers: {
    'change @ui.drawDaysCheckbox': 'changeDrawDays',
    'click @ui.drawDaysInfo': 'clickedDrawDaysInfo'
  },
  modelEvents: {
    'change:drawCount': 'render',
    'change:selectedDays': 'onChangeSelectedDays',
    'change:isSubscription': 'onChangeIsSubscription'
  },
  template(data) {
    return svs.numbergames.game.templates.draw_days(data);
  },
  templateContext() {
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    return {
      showDrawDaysInfo: Boolean(viewOptions.drawDaysInfoDialog),
      drawDays: svs.numbergames.game.draw.drawDays(this.model.get('drawCount'))
    };
  },
  onBeforeAttach() {
    this.removeSelectedClosedDays(true);
  },
  removeSelectedClosedDays(showDialog) {
    if (this.model.get('isSubscription')) {
      return;
    }
    const hasClosedDays = this.model.get('selectedDays').some(drawDay => {
      var _svs$numbergames$game;
      return !((_svs$numbergames$game = svs.numbergames.game.draw[drawDay]) !== null && _svs$numbergames$game !== void 0 && _svs$numbergames$game.isOpen);
    });
    if (hasClosedDays) {
      this.model.set({
        selectedDays: [svs.numbergames.game.draw.upcomingDrawProduct]
      });
      if (showDialog) {
        const dialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'exclamation-sign',
          area: svs.ui.dialog.area.POPUP,
          convertToPopup: false,
          allowDimmerClick: false,
          title: 'Ojsan! Omgången hann stänga för spel!',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: 'Försök igen om några minuter eller ändra speldag'
          }],
          actions: [{
            title: 'OK'
          }]
        });
        svs.ui.dialog.api.add(dialog);
      }
    }
  },
  onChangeIsSubscription() {
    this.removeSelectedClosedDays();
  },
  onChangeDrawDays() {
    const drawDays = [];
    $.each($("input[name=\"draw-days-btn-group\"]:checked"), function () {
      drawDays.push($(this).val());
    });
    this.model.set({
      selectedDays: drawDays
    });
  },
  onChangeSelectedDays(model, selectedDays) {
    const checkboxes = this.getUI('drawDaysCheckbox');
    checkboxes.each((i, el) => {
      const isSelected = selectedDays.indexOf(el.value) > -1;
      const $el = $(el);
      const isChecked = $el.prop('checked');

      if (isSelected === isChecked) {
        return;
      }
      $el.prop({
        checked: isSelected
      });
    });
  },
  onClickedDrawDaysInfo() {
    var _viewOptions$drawDays;
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    viewOptions === null || viewOptions === void 0 || (_viewOptions$drawDays = viewOptions.drawDaysInfoDialog) === null || _viewOptions$drawDays === void 0 || _viewOptions$drawDays.call(viewOptions, this.getUI('drawDaysInfo'));
  }
});

 })(window);